export function roundAndDropTrailingZeros(
  value: number,
  decimalPlaces?: number
) {
  // Round the number to 2 significant digits.
  return value && value % 1 !== 0
    ? Number(value?.toFixed(decimalPlaces || 2))
    : value;
}
